module.exports = __webpack_public_path__ + "img/tel.66e053aa.png";